import React, { useEffect, useState } from 'react';
import Spinner from '../Global/Spinner';
import client from '../../api/client';
import Table from '../../layout/admin/Table';
export default function Logs() {
	const [logs, setLogs] = useState([]);
	const [loading, setLoading] = useState(false);
	const getLogs = async () => {
		try {
			setLoading(true);
			console.log('inside get clients');
			const { data } = await client.get('/logs');
			console.log({ data });
			if (data) setLogs(data.logs);
			setLoading(false);
		} catch (err) {
			setLoading(false);
			return console.error(err);
		}
	};
	useEffect(() => {
		getLogs();
	}, []);
	if (loading) return <Spinner />;
	return (
		<div className=''>
			<Table
				data={logs}
				title='Logs'
			/>
		</div>
	);
}
